import '../../V1/Javascripts/elements/accordion';
import '../../V1/Javascripts/elements/buttons';
import '../../V1/Javascripts/elements/contact-box--reset';
import '../../V1/Javascripts/elements/slider';
import '../../V1/Javascripts/elements/slider-l10n';
import '../../V1/Javascripts/elements/halkaBox';
import '../../V1/Javascripts/elements/line-clamp';
import '../../V1/Javascripts/elements/singleselect';
import '../../V1/Javascripts/elements/datepicker';
import '../../V1/Javascripts/elements/focusarea';
import '../../V1/Javascripts/elements/quicksearch';
import '../../V1/Javascripts/elements/review';
import '../../V1/Javascripts/elements/form-validation';
import '../../V1/Javascripts/elements/navigation--click';
import '../../V1/Javascripts/elements/video-autoplay';
import '../../V1/Javascripts/elements/typo3-messages';

import { initMainNavBurger } from './elements/_navigation--burger';
import { initMainNav } from './elements/_navigation--control';

function initMedatsuV15Scripts() {
  initMainNavBurger();
  initMainNav();
}

if (document.readyState !== 'loading') {
  setTimeout(initMedatsuV15Scripts);
} else {
  document.addEventListener('DOMContentLoaded', initMedatsuV15Scripts, { once: true });
}
